import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CourseStatusForm from '../../../components/forms/CourseStatusForm';
import { useCourseStatusApi } from '../../../hooks/useCourseStatusApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { CourseStatusDTO } from '../../../services/apiClient';

const CourseStatusCreate: React.FC = () => {
  const { create, isLoading } = useCourseStatusApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Course Statuses', href: '/admin/coursestatuses' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: CourseStatusDTO) => {
    try {
      await create(data);
      navigate('/admin/coursestatuses');
    } catch (error) {
      console.error('Error creating CourseStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/coursestatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.CourseStatus.Edit"
    >
        <CourseStatusForm
          initialValues={{} as CourseStatusDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/coursestatuses')}
        />
    </AdminLayout>
  );
};

export default CourseStatusCreate;
